import { Injectable } from "@angular/core";

@Injectable()
export class ShareCard {
  share(shareConfig) {
    window["wx_init_promise"].then((_) => {
      window["wx"].onMenuShareTimeline(shareConfig);
      window["wx"].onMenuShareAppMessage(shareConfig);
    });
    setTimeout(() => {
      setQQShareCard(shareConfig);
    });
  }
}

function setQQShareCard(shareConfig) {
  let { title, desc, imgUrl } = shareConfig;

  let headDom = document.getElementsByTagName("head")[0];
  while (true) {
    let meta = document.querySelector(`meta[sharecard="yes"]`);
    if (!meta) {
      break;
    }
    headDom.removeChild(meta);
  }

  const specs = [
    { property: "og:title", content: title },
    { property: "name", itemprop: "name", content: title },
    { property: "og:description", content: desc },
    {
      property: "description",
      name: "description",
      itemprop: "description",
      content: desc,
    },
    { property: "og:image", content: imgUrl },
    { property: "image", itemprop: "image", content: imgUrl },
  ];
  for (let spec of specs) {
    const metaDom = document.createElement("meta");
    metaDom.setAttribute("sharecard", "yes");
    Object.keys(spec).forEach((key) => metaDom.setAttribute(key, spec[key]));
    headDom.appendChild(metaDom);
  }
}



// WEBPACK FOOTER //
// ./src/services/sharecard.ts